"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processForm = void 0;
const _1 = require(".");
const create_incrementer_1 = require("./create-incrementer");
const process_question_grouping_1 = require("./process-question-grouping");
const process_scope_1 = require("./process-scope");
const processForm = (form, conditions, ordinals) => {
    const formId = form.id ? form.id : (0, create_incrementer_1.getNextFormId)();
    const ordinalIncremeneter = (0, create_incrementer_1.createIncrementer)();
    const createOrdinalForForm = (question) => (0, _1.createOrdinal)(question, ordinalIncremeneter(), (0, process_scope_1.processScope)("FORM", formId), ordinals);
    form.content = form.content.map((entity) => {
        if (!entity || Object.values(entity).length === 0) {
            throw new Error("Form content is empty");
        }
        return Object.assign({}, entity);
    });
    return {
        data: {
            id: formId,
            name: form.name,
            title: form.title,
            questions: {
                connectOrCreate: form.content
                    .map((q) => {
                    if (!q.question && !(q.title || q.subtitle))
                        console.log(q);
                    return (0, _1.processQuestion)({
                        question: q,
                        ordinal: createOrdinalForForm,
                        ordinalIncremeneter,
                        conditions,
                        ordinals,
                        formId,
                        value: "FORM",
                        scopeEntityId: formId,
                    });
                })
                    .flat()
                    .filter((q) => Boolean(q)),
            },
            questionGroupings: {
                connectOrCreate: form.content
                    .map((q) => (0, process_question_grouping_1.processQuestionGrouping)({
                    group: q,
                    ordinal: createOrdinalForForm,
                    conditions,
                    formId,
                    ordinals,
                    value: "FORM",
                    scopeEntityId: formId,
                }))
                    .flat()
                    .filter((q) => Boolean(q))
                    .map((g) => ({ create: g, where: { uniqueKey: g.uniqueKey } })),
            },
        },
    };
};
exports.processForm = processForm;
